module.exports = __webpack_public_path__ + "img/del-normal.46b2f725.svg";